/**
  * 测评参数模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const evaApi = {
    GetDataList: `${base.qa}/Evaluparams/GetDataList`,
    SaveData: `${base.qa}/Evaluparams/SaveData`,
    DelData: `${base.qa}/Evaluparams/DelData`,
}

const eva = {
    GetDataList (params) {
        return axios.get(evaApi.GetDataList, { params: { specid: params.specid, pageindex: params.pageindex, pagesize: params.pagesize } })
    },
    SaveData (params) {
        console.log(params);
        return axios.post(evaApi.SaveData, params)
    },
    DelData (params) {
        return axios.post(evaApi.DelData, params)
    },
}


export default eva;